<script setup lang="ts">
import { computed } from 'vue'
import { useLayout } from '@/layout/composables/layout.ts'
const { toggleMenu } = useLayout()
import { useRouter } from 'vue-router'
import { useAuthorizationStore } from '@/components/authorization/model/AuthorizationRepository.ts'
import { useGlobalStateStore } from '@/components/commons/model/GlobalState.ts'

const router = useRouter()
const version = import.meta.env.VITE_APP_VERSION
const globalState = useGlobalStateStore()

const paintShopOptions = computed(() => globalState.getUserPaintShopsAsOptions)
const hasMultiplePaintShops = computed(() => paintShopOptions.value.length > 1)
const selectedPaintShopLabel = computed(() =>
  paintShopOptions.value.find(o => o.value === globalState.selectedPaintShopId)?.label ?? globalState.selectedPaintShopId
)

const logOut = () => {
  useAuthorizationStore().logout()
}

const refresh = () => {
    window.location.reload()
}

</script>

<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
        <i class="pi pi-bars"></i>
      </button>
      <span class="layout-topbar-logo" @click="refresh">
      <img :src="'/layout/images/logo-white.svg'" alt="logo"/> Paintshop <small class="text-sm opacity-75">v{{ version }}</small>
      </span>
    </div>

    <div class="layout-topbar-actions">
      <div v-if="paintShopOptions.length > 0" class="paint-shop-selector">
        <Select
          v-if="hasMultiplePaintShops"
          v-model="globalState.selectedPaintShopId"
          :options="paintShopOptions"
          option-label="label"
          option-value="value"
          id="topbar-paint-shop-select"
          class="paint-shop-dropdown"
        />
        <span v-else class="paint-shop-label">
          <i class="pi pi-building mr-1"></i>{{ selectedPaintShopLabel }}
        </span>
      </div>
      <button type="button" class="layout-topbar-action" @click="logOut()">
        <i class="pi pi-sign-out"></i>
      </button>
      <button type="button" class="layout-topbar-action"  @click="router.push('/user/profile')">
        <i class="pi pi-cog"></i>
      </button>
    </div>
  </div>
</template>

<style scoped>
.paint-shop-selector {
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}

.paint-shop-dropdown {
  min-width: 10rem;
}

.paint-shop-label {
  color: var(--text-color);
  font-size: 0.875rem;
  white-space: nowrap;
}
</style>
